
import Navigation from "../modules/_navigation.js";
import ObjectFit from "../modules/_object-fit.js";
import Print from "../modules/_print.js";
import Buttons from "../modules/_buttons.js";
import VideoModal from "../modules/_video-modal";
import InstructionsSlider from "../modules/_instructions-slider";
import FilterInstructions from "../modules/_filter-instructions";
import SidebarFilter from "../modules/_sidebar-filter";
import SurveyModal from '../modules/_survey-modal';

/* Register modules
 ----------------------------------------------------------*/
(function(){
  new Navigation().ready();
  new ObjectFit().ready();
  new Print().ready();
  new Buttons().ready();
  new VideoModal().ready();
  new InstructionsSlider().ready();
  new FilterInstructions().ready();
  new SidebarFilter().ready();
  new SurveyModal().ready();
})()

